import React from 'react';
import { classNames } from '../../utils/classNames';

type CardProps = {
  className?: string;
  children: React.ReactNode;
};

export const Card: React.FC<CardProps> = ({ className, children }) => (
  <section className={classNames('card', className)}>{children}</section>
);

type CardHeaderProps = {
  className?: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  children?: React.ReactNode;
};

export const CardHeader: React.FC<CardHeaderProps> = ({
  className,
  title,
  description,
  actions,
  children,
}) => (
  <div
    className={classNames(
      'card-header flex flex-col gap-3 md:flex-row md:items-center md:justify-between',
      className
    )}
  >
    <div className="min-w-0 flex-1">
      {title ? <h3 className="text-base font-semibold text-[var(--app-heading)]">{title}</h3> : null}
      {description ? <p className="mt-1 text-sm text-[var(--app-text-muted)]">{description}</p> : null}
      {!title && !description ? children : null}
    </div>
    {actions ? (
      <div className="flex w-full flex-wrap items-center gap-2 md:ml-4 md:w-auto md:justify-end">
        {actions}
      </div>
    ) : null}
  </div>
);

type CardBodyProps = {
  className?: string;
  children: React.ReactNode;
};

export const CardBody: React.FC<CardBodyProps> = ({ className, children }) => (
  <div className={classNames('card-body', className)}>{children}</div>
);

type CardFooterProps = {
  className?: string;
  children: React.ReactNode;
};

export const CardFooter: React.FC<CardFooterProps> = ({ className, children }) => (
  <div className={classNames('card-body border-t border-[var(--app-border)] bg-surface-subtle', className)}>
    {children}
  </div>
);

export default Card;

